"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Add_1 = tslib_1.__importDefault(require("@mui/icons-material/Add"));
const material_1 = require("@mui/material");
const CreateButton = (props) => {
    const { createButtonText = "Create" } = (0, material_1.useThemeProps)({ props, name: "CreateButton" });
    const { IconProps, ...rest } = props;
    return (react_1.default.createElement(material_1.Button, { ...{
            startIcon: react_1.default.createElement(Add_1.default, { "data-testid": "AddIcon", ...IconProps }),
            variant: "outlined",
            color: "primary",
            ...rest,
        } }, createButtonText));
};
exports.default = CreateButton;
